import Amazon from './amazon'

export default Amazon